import React, { MouseEventHandler } from 'react';
import VoxelText from '../Text/VoxelText';
import VoxelCheckbox from '../Forms/VoxelCheckbox';
import VoxelChip from '../Chips/VoxelChip';

export interface VoxelAppBarItemProps {
  href: string;
  selected?: boolean;
  onClick: MouseEventHandler<HTMLAnchorElement>;
  endAdornment?: React.ReactNode;
  type?: 'small' | 'large';
}

export const VoxelAppBarItem: React.FC<VoxelAppBarItemProps> = ({
  onClick,
  href,
  children,
  selected,
  type = 'small',
  endAdornment,
}) => {
  return (
    <a
      onClick={onClick}
      href={href}
      className={`
            h-full
            flex flex-row items-center gap-1.5
            select-none
            px-5 py-1
            hover:bg-voxel-gray-50
            whitespace-nowrap
            ${selected ? 'bg-voxel-gray-100' : 'bg-transparent'}
        `}
    >
      <VoxelText
        variant={type === 'large' ? 'appbar-large' : 'appbar'}
        color={selected ? 'medium' : 'slight'}
      >
        {children}
      </VoxelText>
      {endAdornment}
    </a>
  );
};

export default VoxelAppBarItem;
